import script from "./GanttChartComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./GanttChartComponent.vue?vue&type=script&setup=true&lang=ts"

import "./GanttChartComponent.vue?vue&type=style&index=0&id=4a60dcde&lang=css"

const __exports__ = script;

export default __exports__